<template>
    <div>
        <Appbar/>
        <HeroBanner/>
        <div class="container">
            <div class="row justify-content-center" v-if="success">
                <div class="col-md-8 my-5">
                    <div class="alert alert-success m-3 p-5">
                        <p>Thank you for submitting your critique with us.</p>
                        <p>Our team will review and if it meets our standard, it will be approved</p>
                         <router-link class="btn btn-danger" to="/challenge">Go to challenges</router-link>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center" v-if="!success">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            <h3>LEADER'S VISION</h3>
                            <!-- <p>
                                <strong>
                                    Heading :
                                </strong>
                                {{currentChallenge.heading}}
                            </p> -->
                            <p>
                                <!-- <strong>
                                    Summary:
                                </strong> -->
                                {{currentChallenge.summary}}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-8 my-2">
                    <h2>Add Critique</h2>
                    <router-link to="/challenge" class="btn">
                        Back
                    </router-link>
                </div>
                <div class="col-md-8 py-5">
                   <form action="" @submit.prevent="addLeadersVision" enctype="multipart/form-data">
                    <div class="form-group">
                            <label for="name">Full Name <strong class="text-danger">(required)</strong> </label>
                            <input required type="text" name="name" class="form-control" v-model="name">
                    </div>
                    <div class="form-group">
                       
                            <label for="DOB">Age <strong class="text-danger">(required)</strong></label>
                            <input type="number" min="0" required name="DOB" class="form-control" v-model="age" >
                    </div>
                    <p class="p-0">Gender <strong class="text-danger">(required)</strong></p>
                    <div class="form-check ml-2">
                        <input v-model="gender" class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" 
                        value="Male" checked required>
                        <label class="form-check-label" for="exampleRadios1">
                            Male
                        </label>
                    </div>
                    <div class="form-check ml-2">
                        <input class="form-check-input" v-model="gender" type="radio" name="exampleRadios" id="exampleRadios2"
                         value="Female">
                        <label class="form-check-label" for="exampleRadios2">
                            Female
                        </label>
                    </div>
                    <div class="form-group" >
                            <label  for="certification_number">Market <strong class="text-danger">(required)</strong></label>
                               <multiselect 
            
                                    id="sales-markets"
                                    v-model="market_id" deselect-label="Can't remove this value" track-by="id" 
                                    label="name" placeholder="Select Maket" :options="markets" :allow-empty="false" >
                                </multiselect>
                    </div>
                    <div class="form-group">
                            <label for="title">Heading <strong class="text-danger">(required)</strong> </label>
                            <input required type="text" name="heading" class="form-control" v-model="heading">
                    </div>
                    <div class="form-group">
                            <label for="statement">Summary <strong class="text-danger">(required)</strong></label>
                            <textarea required name="statement" class="form-control" rows="15" v-model="summary"></textarea >
                    </div>
                      <div class="form-group">
                           <label for="basic-url">Upload Your Photo <strong class="text-danger">(optional)</strong></label>
                            <div class="custom-file">
                            <input type="file" accept="image/*" class="custom-file-input" id="validatedCustomFile" @change="uploadImage" >
                            <label class="custom-file-label" for="validatedCustomFile">
                               {{picTitle ? picTitle :"Choose file..."}}
                            </label>
                            <!-- <small>{{picTitle}}</small> -->
                        </div>
                       </div>
                    <div class="form-group">
                            <label for="basic-url">Attach PDF <strong class="text-danger">(optional)</strong> </label>
                            <div class="custom-file">
                            <input accept="application/pdf" type="file" class="custom-file-input" id="validatedCustomFile" @change="uploadPdf" >
                            <label class="custom-file-label" for="validatedCustomFile">{{pdfTitle ? pdfTitle :"Choose file..."}}</label>
                            </div>
                    </div>
                    <div class="form-group">
                                <label for="basic-url">Attach Document <strong class="text-danger">(optional)</strong></label>
                            <div class="custom-file">
                            <input accept=".doc,.docx,"  type="file" class="custom-file-input" id="validatedCustomFile" @change="uploadDoc" >
                                {{docTitle ? docTitle :"Choose file..."}}
                            <label class="custom-file-label" for="validatedCustomFile">
                            </label>
                            <small>{{docTitle}}</small>
                            </div>
                    </div>
                        <label for="basic-url">Add Support Video  <strong class="text-danger">(optional)</strong></label>
                        <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon3">https://www.youtube.com/</span>
                        </div>
                        <input v-model="video" type="text" class="form-control" id="basic-url" aria-describedby="basic-addon3">
                        </div>

                          <div class="alert alert-danger" v-if="marketError">
                                 <strong class="" >{{marketError}}</strong>
                        </div>
                    <button class="btn btn-lg myBtn float-right" style="font-size:.9em" type="submit">Submit</button>
                    </form>
            </div>
        </div>
        </div>
        <FinalFooter />
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import Appbar from '../appBar'
import HeroBanner from './Header'
import url from '../../helpers/url'
import axios from 'axios'
import toasterMixin from '../../mixins/toasterMinxin'
import FinalFooter from '../../components/FinalFooter'
    export default {
        components:{
            Multiselect,
            Appbar,
            HeroBanner,
            FinalFooter
            
        },
        data() {
            return {
                markets:[],
                gender:'',
                issueArea:'',
                name:'',
                pic:'',
                age:'',
                heading:'',
                summary:'',
                market_id:'',
                pdf:'',
                video:'',
                doc:'',
                picTitle:'',
                pdfTitle:'',
                docTitle:'',
                currentChallenge:{},
                success:false,
                marketError:null
            }
        },
        methods: {
             uploadImage(event) {
                this.pic = event.target.files
                this.picTitle = this.pic[0].name 
                if(this.pic) {
                    let size
                    for( let i = 0; i < this.pic.length; i++) {
                       size  = Math.round(( this.pic[i].size  / 1024)); 
                    }
                    if( size > 2048) {
                        this.error = true
                        this.toast({
                            message:'Picture Size is too big',
                            type:'error'
                        })
                        return;
                    }
                    
                }  
            },
            uploadDoc() {
                this.doc = event.target.files
                this.docTitle = this.doc[0].name 
                 if(this.doc) {
                    let size
                    for( let i = 0; i < this.doc.length; i++) {
                       size  = Math.round(( this.doc[i].size  / 1024)); 
                    }
                    if( size > 2048) {
                        this.error = true
                        this.toast({
                            message:'Document Size is too big',
                            type:'error'
                        })
                        return;
                    }
                    
                }  
            },
            uploadPdf() {
                this.pdf = event.target.files
                this.pdfTitle = this.pdf[0].name 
                 if(this.pdf) {
                    let size
                    for( let i = 0; i < this.pdf.length; i++) {
                       size  = Math.round(( this.pdf[i].size  / 1024)); 
                    }
                    if( size > 2048) {
                        this.error = true
                        this.toast({
                            message:'PDF Size is too big',
                            type:'error'
                        })
                        return;
                    }
                    
                }    
            },
            addLeadersVision() {
                //validation
                if(this.market_id === '') {
                    this.marketError = "Please market is required."
                    return
                } else {
                    this.marketError = ''
                }
              const formData = new FormData()
              formData.append('name', this.name)
              formData.append('age', this.age)
              formData.append('heading', this.heading)
              formData.append('summary', this.summary)
              formData.append('gender', this.gender)
              formData.append('market', this.market_id.id)
              formData.append('video', this.video)
              formData.append('leaders_vision_id', this.$route.params.challengeID)
              if(this.pic) {
                    for( let i = 0; i < this.pic.length; i++) {
                    formData.append('image  ', this.pic[i])
                    }
                }else{
                    formData.append('image','')
                }
               if(this.pdf) {
                    for( let i = 0; i < this.pdf.length; i++) {
                    formData.append('pdf', this.pdf[i])
                    }
               }else{
                   formData.append('pdf','')
               }
               if(this.doc) {
                    for( let i = 0; i < this.doc.length; i++) {
                    formData.append('doc', this.doc[i])
                    }
               }else{
                   formData.append('doc','')
               }
               this.$store.dispatch('addThinkersCretique', formData)
                .then(response => {
                    if(response) {
                        this.success = true
                    }
                }).catch(err => {
                    if(err?.response?.data == undefined) {
                        this.toast({
                            message:'Network error. Check network connection and try again.',
                            type:'error'
                        })
                    }
                })
            }
            
        },
        mounted() {
            document.querySelector('body').setAttribute('style', 'background-color:#f6f6f6')
            axios.get(`${url()}/api/market/`).then( response => {
                this.markets = response.data
            })
            this.$store.dispatch('fetchLeadersVision').then(response => {
                const data = response.data.find( challenge => challenge.id == this.$route.params.challengeID)
                this.currentChallenge = data
            })
    },
    beforeDestroy() {
        document.querySelector('body').removeAttribute('style')
    },
    }
</script>

<style  scoped>
input,select, textarea,.custom-file-label, .myBtn{
    background-color:#b62631;
    color: #FFF;
}
h2{
    display:inline;
}
a{
    float:right;
    border:2px solid black;
}
   @media screen and (max-width: 600px) {
       h1 {
           font-size: 1.8em;
           margin-top:50px;
       }
   }
</style>